"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatThreadTypeEnum = void 0;
/** Типы нитей */
var ChatThreadTypeEnum;
(function (ChatThreadTypeEnum) {
  /** 1:1 */
  ChatThreadTypeEnum[ChatThreadTypeEnum["private"] = 1] = "private";
  /** Группа */
  ChatThreadTypeEnum[ChatThreadTypeEnum["group"] = 2] = "group";
  /** Митинг = класс */
  ChatThreadTypeEnum[ChatThreadTypeEnum["meeting"] = 3] = "meeting";
  /**
   * @description Чат 1:1 внутри митинга
   * @deprecated По сути, то же самое, что и просто чат 1:1
   */
  ChatThreadTypeEnum[ChatThreadTypeEnum["meeting_private"] = 5] = "meeting_private";
  /** Классрум */
  ChatThreadTypeEnum[ChatThreadTypeEnum["classroom"] = 6] = "classroom";
})(ChatThreadTypeEnum = exports.ChatThreadTypeEnum || (exports.ChatThreadTypeEnum = {}));
